import React from "react";
import { Link } from "react-router-dom";

const Footer = ({ data }) => {
  if (!data) return null;

  const {
    logoText,
    description,
    socialLinks,
    usefulLinks,
    contact,
    developer,
    copyright,
    policies,
  } = data;

  return (
    <footer className="footer-section">
      <div className="footer-top">
        <div className="footer-container">
          {/* Logo + Description */}
          <div className="footer-about">
            <h2 className="footer-logo">
              <span className="e-dot">.</span>
              {logoText}
            </h2>
            <p>{description}</p>

            {/* Social Icons - using fa fa-* format */}
            <div className="social-icons">
              {socialLinks.map((link, idx) => (
                <a key={idx} href={link.url} target="_blank" rel="noreferrer">
                  <i className={`fa fa-${link.icon}`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Useful Links */}
          <div className="footer-links">
            <h3>Useful Links</h3>
            <ul style={{ paddingLeft: 0, listStyle: 'none' }}>
              {usefulLinks.map((link, idx) => (
                <li key={idx} style={{ marginBottom: 10 }}>
                  {link.url.startsWith('/') ? (
                    <Link
                      to={link.url}
                      style={{ color: '#fff', textDecoration: 'none', fontWeight: 500 }}
                      onClick={
                        ["/about", "/products", "/contact"].includes(link.url)
                          ? () => window.scrollTo({ top: 0, behavior: 'smooth' })
                          : undefined
                      }
                    >
                      {link.label}
                    </Link>
                  ) : (
                    <a
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      style={{ color: '#fff', textDecoration: 'none', fontWeight: 500 }}
                    >
                      {link.label}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h3>Visit Us</h3>
            <ul>
              <li>
                <i className="fa fa-phone" style={{ color: '#2563eb' }}></i> {contact.phone}
              </li>
              <li>
                <i className="fa fa-envelope" style={{ color: '#2563eb' }}></i> {contact.email}
              </li>
              <li>
                <i className="fa fa-map-marker" style={{ color: '#2563eb' }}></i> {contact.address}
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Bottom Strip */}
      <div className="footer-bottom">
        <p className="developer">
          {developer.text.includes(developer.phone) ? (
            developer.text
          ) : (
            <>
              {developer.text} |{" "}
              <a href={`tel:${developer.phone}`}>{developer.phone}</a>
            </>
          )}
        </p>
        <p className="copyright">
          {/* {copyright} */}
     © {new Date().getFullYear()} Zip Accounts. All Rights Reserved.

        </p>
      </div>
    </footer>
  );
};

export default Footer;
